import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { mediaState } from '../atom';
import type { Media } from '../types';

export const useMediaUpsert = () => {
  const upsert = useAtomCallback(
    useCallback((_get, set, media: Media) => {
      set(mediaState(media.id), media);
    }, [])
  );

  return {
    upsert,
  };
};
